import { criptografarDados, criptografarDadosBase64, decriptografarDados } from "../utils/CryptoUtils";

export const recuperarCache = (chave) => {
  const chaveCriptografada = criptografarDadosBase64(chave);
  const cache = localStorage.getItem(chaveCriptografada);

  if (cache) return decriptografarDados(cache);

  return null;
};

export const recuperarCacheDescriptografado = (chave) => localStorage.getItem(chave);

export const salvarCacheCriptografado = (chave, valor) => {
    const chaveCriptografada = criptografarDadosBase64(chave);
    const valorCriptografado = criptografarDados(valor);
    localStorage.setItem(chaveCriptografada, valorCriptografado);
}

export const salvarCache = (chave, valor) => localStorage.setItem(chave, valor );

export const removerCache = (chave) => localStorage.removeItem(chave);

export const limparCache = () => localStorage.clear();


